import {blocksApi} from '../api';
import {useMutation, useQuery, useQueryClient, UseMutationResult, UseQueryResult} from '@tanstack/react-query';
import {BlockModel, EditBlockParams} from '../model';
import {useNotifications} from '../../../shared';

type UseBlockByIdResult = {
  getBlock: UseQueryResult<BlockModel, Error>;
  updateBlockMutation: UseMutationResult<BlockModel, Error, EditBlockParams>;
  deleteBlockMutation: UseMutationResult<void, Error, string>;
};

export const useBlockById = (blockId: string): UseBlockByIdResult => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const getBlock = useQuery({
    queryKey: ['blocks', blockId],
    queryFn: () => blocksApi.getBlockById(blockId),
    enabled: Boolean(blockId),
  });

  const updateBlockMutation = useMutation({
    mutationFn: ({blockId, name, title}: EditBlockParams) => blocksApi.updateBlock({blockId, name, title}),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['blocks']});
      createNotification({
        title: 'Блок успешно обновлен',
        name: 'updateBlock',
        theme: 'success',
      });
    },
  });

  const deleteBlockMutation = useMutation({
    mutationFn: (blockId: string) => blocksApi.deleteBlock(blockId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['blocks']});
      createNotification({
        title: 'Блок успешно удален',
        name: 'deleteBlock',
        theme: 'success',
      });
    },
  });

  return {
    getBlock,
    updateBlockMutation,
    deleteBlockMutation,
  };
};
